import { Row } from "@tanstack/react-table"
import { PendingSubscriptionFull } from "../../../../types"
import { getPendingSubscriptionStatus } from "../../../utils/dream-rate"

interface DreamRateFilterType {
  status?: string | string[] // "active" | "pending" or array of them
  desired_rate_range?: string | string[] // "3-4", "4-5", "5-6", "6-7", "7-8" or array of them
}

export const dreamRateFilter = (
  row: Row<PendingSubscriptionFull>,
  columnId: string,
  filterValue: DreamRateFilterType
): boolean => {
  // Filter function is working correctly

  const conditions: boolean[] = []

  // Status filter (uses centralized helper for consistency)
  if (filterValue.status) {
    const statusValues = Array.isArray(filterValue.status)
      ? filterValue.status
      : [filterValue.status]

    const rowStatus = getPendingSubscriptionStatus(row.original)
    const statusMatches = statusValues.includes(rowStatus)

    conditions.push(statusMatches)
  }

  // Desired rate range filter
  if (filterValue.desired_rate_range) {
    const triggerRate = row.original.trigger_rate
    const rate = triggerRate // trigger_rate is already stored as percentage
    const rateValues = Array.isArray(filterValue.desired_rate_range)
      ? filterValue.desired_rate_range
      : [filterValue.desired_rate_range]

    // Rate range filtering logic

    const rateMatches = rateValues.some(rateValue => {
      const result = (() => {
        switch (rateValue) {
          case "3-4":
            return rate >= 3 && rate < 4
          case "4-5":
            return rate >= 4 && rate < 5
          case "5-6":
            return rate >= 5 && rate < 6
          case "6-7":
            return rate >= 6 && rate < 7
          case "7-8":
            return rate >= 7 && rate < 8
          default:
            return false
        }
      })()

      return result
    })

    conditions.push(rateMatches)
  }

  // If at least one filter is set, return true if ALL conditions are met (AND logic between categories).
  // If no filter is set, return true so that the row is not filtered out.
  const result = conditions.length
    ? conditions.every(condition => condition)
    : true

  // Return filter result

  return result
}
